import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import publishSdkEvent, { SdkEventType } from './publishSdkEvent';

const openRegistrationModal = () => {
  publishSdkEvent({
    event: SdkEventType.OpenRegistrationScreen,
    data: {
      source: MINIAPP_PACKAGE_ID,
      action: 'click',
      action_button: MINIAPP_PACKAGE_ID,
    },
  });
};

export default openRegistrationModal;
